import { useEffect, useState } from "react";
import Modal from "../../../components/Modal";
import Button from "../../../components/Button/Button";
import useStyles from "../styles";
// import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import { Grid } from "@mui/material";
import { httprequest } from "../../../data/api";
import { useParams } from "react-router-dom";
import BreadCrumb from "../../../components/BreadCrumb/Breadcrumb";
import Table from "../../../components/Table/Table";
import { TableSearch } from "../../../components/Table/TableActions";
import { ToastContainer, toast } from "react-toastify";
import InputGroup from "../../../components/FormComponent/InputGroup";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import Layout from "../../../components/Layout/Layout";

const GELL_ALL_SUBJECT_ENDPOINT = "/admin/v1/subjects";
const GET_ALL_TEACHERS_ENDPOINT = "/admin/v1/teachers";

const AllSubjectInfo = () => {
  const { id } = useParams();
  const classes = useStyles();
  const [searchResult, setSearchResult] = useState([]);
  const [currentRow, setCurrentRow] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [editmodal, setEditModal] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [subjectsData, setSubjectsData] = useState([]);
  const [teachersdata, setTeachersData] = useState([]);
  const [showvirtualoption, setShowVirtualOption] = useState(false);

  const handleEditModal = (row) => {
    setCurrentRow(row);
    setEditModal(!editmodal);
    // eslint-disable-next-line no-console
    console.log("button clicked");
  };

  const handleSelectChange = (e) => {
    // const { value } = e.target;
    // setClassForm({ ...select, option: value });
    setShowVirtualOption(e.target.value === "virtual");
  };

  const handleDeleteModal = (row) => {
    setCurrentRow(row);
    setDeleteModal(!deleteModal);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
  };

  const getAllSubjects = () => {
    setIsLoading(true);
    httprequest.get(GELL_ALL_SUBJECT_ENDPOINT).then((res) => {
      setIsLoading(false);
      setSubjectsData(res?.data?.data);
      setSearchResult(res?.data?.data);
    }).catch((err) => {
      setIsLoading(false);
      toast.error(err?.response?.data);
    });
  };
  // eslint-disable-next-line no-console
  console.log(subjectsData);

  const getAllTeachers = () => {
    httprequest.get(`${GET_ALL_TEACHERS_ENDPOINT}/${id}`).then((res) => {
      setTeachersData(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };
  // eslint-disable-next-line no-console
  console.log(teachersdata);

  useEffect(() => {
    // The data will be from the AllSubject get api endpint
    getAllTeachers();
    setSearchResult(getAllSubjects);
  }, []);

  const columns = [
    {
      name: "Subject",
      selector: row => row?.name
    },
    {
      name: "Date Created",
      selector: row => row?.created_at?.substring(0, 10)
    },
    {
      name: "Date Updated",
      selector: row => row?.updated_at?.substring(0, 10)
    },
    {
      name: "Status",
      center: true,
      cell: (row) => (<Badge status={row?.status} />)
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button onClick={() => handleEditModal(row)} className="table-action-icon">
            <Icon icon="heroicons:pencil-square-solid" />
          </button>
          <button
            onClick={() => handleDeleteModal(row)}
            className="table-action-icon delete-icon"
          >
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }

  ];

  // --| Filter Shelf21 table using name, email and class
  const handleSubjectSearch = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = subjectsData?.filter((data) => valArray?.every(
      (word) => data?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                                                  data?.description
                                                    ?.toLowerCase()
                                                    .includes(word.toLowerCase()) ||
                                                  data?.category
                                                    ?.toLowerCase()
                                                    .includes(word.toLowerCase()) ||
                                                    data?.status
                                                      ?.toLowerCase()
                                                      .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            <div>
              <BreadCrumb
                link_one="/schools"
                link_one_name="Schools"
                active="All Subjects"
                description="See all subject in"
              />
            </div>
          </div>
          <div>
            <Table data={searchResult} columns={columns} isLoading={isloading} subHeader={true} pagination subHeaderComponent={
              <TableSearch placeholder="Search here..." searchTableFunc={handleSubjectSearch} />
            }
            />
            {/*  Edit Modal */}
            <Modal
              title="Edit a Class"
              subtitle={
                <div>Edit your class</div>}
              modalContent={
                <>
                  <Grid container spacing={2} className="input-padding">
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <InputGroup
                        label="Class Name"
                        margin="normal"
                        placeHolder="Enter class name"
                        inputType="text"
                        inputName="class_name"
                      />
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <SelectGroup label="Class Teacher" children={
                        <select>
                          <option value="">--- Select ---</option>
                          {teachersdata?.map((teacher) => {
                            return (
                              <option key={teacher?.member_id} value={teacher?.member_id}>{`${teacher?.first_name} ${teacher?.last_name}`}</option>
                            );
                          })}
                        </select>
                      }
                      />
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <SelectGroup label="Class Type" children={
                        <select onClick={handleSelectChange}>
                          <option value="select">--- Select ---</option>
                          <option value="virtual">Virtual</option>
                          <option value="physical">Physical</option>
                        </select>
                      }
                      />
                    </Grid>
                    { showvirtualoption?.class_type === "virtual" && (
                      <>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                          <InputGroup
                            label="Start Time"
                            margin="normal"
                            inputType="time"
                            inputName="start_time"
                          />
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                          <InputGroup
                            label="End Time"
                            margin="normal"
                            inputType="time"
                            inputName="end_time"
                          />
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                          <InputGroup
                            label="Virtual Date"
                            margin="normal"
                            inputType="date"
                            inputName="virtual_class_date"
                          />
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                          <InputGroup
                            label="Meeting Link"
                            margin="normal"
                            inputType="text"
                            inputName="meeting_link"
                          />
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <InputGroup
                            label="Add Email(s) seperated by commas"
                            margin="normal"
                            placeHolder="Add Emails"
                            inputType="text"
                            inputName="attendees"
                          />
                        </Grid>
                      </>
                    )}
                  </Grid>
                </>
              }
              modalFooter={
                <>
                  <div className={classes.modalFooterBtn}>
                    <Button variant="primary" buttonSize="full" color="btndefault" buttonName="Edit Class" />
                  </div>
                </>
              }
              isopen={editmodal}
              closeModal={handleEditModal}
            />
            {/* Delete Modal */}
            <Modal
              title="Delete Subject"
              subtitle={
                <div>Are you sure you want to delete <span className="modal-name-highlight">{currentRow?.title}</span>. Deleting is a permanent action`
                </div>}
              modalContent={
                <>

                </>
              }
              modalFooter={
                <>
                  <Button variant="danger" buttonName="Delete Subject" buttonSize="full" color="btndefault" />
                </>
              }
              isopen={deleteModal}
              closeModal={handleCloseDeleteModal}
            />
          </div>
          <ToastContainer />
        </>
      }
    />
  );
};

export default AllSubjectInfo;
